import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from './CommonFunction';
import { Subscription } from 'rxjs';
import { CustomDateFormat } from './CustomDateFormat';
import { DatePipe } from '@angular/common';
import { ColumnApi, GridApi } from 'ag-grid-community';
@Component({
    selector: 'paymentVenOSTemplate',
    template: require('./PaymentVenOSTemplate.html'),
    styles: [``]
})
export class PaymentVenOSTemplateComponent implements OnInit {
    @Input('vendorname') Vendor_Name: any;
    @Input('name') Name: any;
    @Input('vendorid') Vendor_ID: any;
    @Input("dValue") dvalue: any;
    @Output() totalAmount = new EventEmitter<any>();

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CommonFunction, CustomDateFormat, DatePipe]
    bsConfig: any;
    busy: Subscription;
    public overlayNoRowsTemplate: any;
    toastWarningMsg(msg) {
        this.toast({ type: 'warning', title: msg });
    }
    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public commonFunction: CommonFunction, public customDateFormat: CustomDateFormat, public datePipe: DatePipe) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.unitInfo.dateInputFormat;
        //   console.log("this.bsConfig", this.bsConfig);

        this.defaultColDef = {
            resizable: true,
        };

        $(document).ready(function () {
            var header = $('paymentVenOSTemplate .modal-header').height();
            var body = $('paymentVenOSTemplate').parent().height();
            var appHeight = body - header + 'px !important';
            $('.modal-body .table-responsive.outstanding').attr('style', 'height:' + appHeight);
        })
    }

    dateFormat: any;

    gridColumnApiVendorOustanding: ColumnApi;
    gridApiVendorOustanding: GridApi;
    paginationConf: any;
    d: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    modalReference: NgbModalRef;
    public overlayLoadingTemplate: any;
    public hotkeyList: Hotkey[];
    Config_Leger_From_Date: any;
    Custfiltervalue: any;
    searchobject: any;

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });
    rowSelectionMultiple: string = 'multiple';

    ngOnInit(): void {
        //   console.log('Common Vendor Ledger Template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.overlayNoRowsTemplate = "<h4> No record to show. </h4>";
        this.paginationConf = UserSettings.enablePagination;

        if ("SystemConfigDetails" in localStorage) {
            var data = JSON.parse(localStorage.getItem('SystemConfigDetails'));
            var ConfigDate = data.filter(function (item) {
                return item.Config_Name === 'Customer Ledger From Date'
            });
            //var currentdate = moment(new Date()).format('YYYY');
            this.Config_Leger_From_Date = (ConfigDate ? ConfigDate[0].Config_Value : '');
            if (this.Config_Leger_From_Date) {
                this.Config_Leger_From_Date = (this.unitInfo.CurrentFYear + "-" + this.Config_Leger_From_Date);
                this.Config_Leger_From_Date = moment(this.Config_Leger_From_Date).format(this.dateFormat.dateInputFormat);
                //   console.log("Customer Ledger From Date", moment(this.Config_Leger_From_Date).format(this.dateFormat.dateInputFormat));
            } else {
                this.Config_Leger_From_Date = this.oneMonthAgo();
            }
        }

        this.vendoroutstandingDef = [
            { headerName: 'Doc Type', field: 'DocType_Desc', width: 200 },
            { headerName: 'Doc No', field: 'Doc_No', width: 220,  },
            {
                headerName: 'Doc Date', field: 'Post_Date', width: 100, cellRenderer: (data) => {
                    return data.value ? moment(data.value).format(this.unitInfo.dateInputFormat) : "";
                }
            },
            { headerName: 'Bill No', field: 'Bill_No', width: 200 },
            {
                headerName: 'Due Date', field: 'Due_Date', width: 100,  suppressSizeToFit: true, cellRenderer: (data) => {
                    return data.value ? moment(data.value).format(this.unitInfo.dateInputFormat) : "";
                }
            },
            { headerName: 'Over Days', field: 'OverDays', width: 150, cellStyle: { 'textAlign': "right" },  cellRenderer: this.overDaysCellRenderer.bind(this) ,},
            { headerName: 'Total Bill Amount', width: 150, field: 'Total_BillAmount', cellStyle: { 'textAlign': "right" } },
            { headerName: 'Adj Amt', field: 'ClrAmt', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Outstanding', field: 'Outstanding', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: '', field: 'EntryType' },
            { headerName: 'Action', field: '_', suppressSizeToFit: true, width: 80, pinned:'right',  selectable: true, 
            // checkboxSelection: true,
            checkboxSelection: (params) => { return this.f_chkString(params.data.EntryType)  == 'Cr.' ? true : false; }, 
            // headerCheckboxSelection: true, 
            headerCheckboxSelectionFilteredOnly: true,  }
        ];
        this.initHotkeys();
        setTimeout(() => {
            $("#filter-text-box1").focus();
        }, 200);
        this.searchobject = {};

        this.Custfiltervalue = '';
        this.EnableDateRange();
        // this.searchobject.From_Date = this.Config_Leger_From_Date;
        // this.searchobject.To_Date = new Date();

        this.vendorOustandingmain();
        this.VendOutstandingRowData = [];
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";
    }

    initHotkeys() {
        this.hotkeyList = [];
        let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('paymentVenOSTemplate #excelbtn').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrle);
        this.hotkeysService.add(ctrle);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
            $("paymentVenOSTemplate #filter-text-box1").focus();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    VendOutstandingRowData: any;
    VendOutstandingRowData_1: any;
    vendoroutstandingDef: any;
    vendorOustandingmain() {
        let date = new Date();
        let From_Date = moment(date).format('YYYY-MM-DD');
        let data = {
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "FiscalYear": this.unitInfo.CurrentFYear,
            "sMode": '',
            "Doctype": '',
            "PartyType": "VEN",
            "Party_ID": this.Vendor_ID,
            "PostDate": From_Date,
            "FI_Id": '',
            "From_Date": moment(this.searchobject.From_Date).format('YYYY-MM-DD'),
            "To_Date": moment(this.searchobject.To_Date).format('YYYY-MM-DD')
        }
        var self = this;
        this.busy = this.http.post('/api/purchaseinvoices/getInvoiceListForPayment_Datefilter', data)
            .subscribe((response: any) => {
                this.VendOutstandingRowData = response;
                this.VendOutstandingRowData_1 = response;
                this.TotalRowData = { "Doc_No": "Total Count : " + this.VendOutstandingRowData.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

                this.TotalRowData.Total_BillAmount = (this.VendOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                this.TotalRowData.ClrAmt = (this.VendOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                this.TotalRowData.Outstanding = (this.VendOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);

                setTimeout(() => {
                    this.gridApiVendorOustanding.setPinnedBottomRowData([this.TotalRowData]);
                }, 200);
                setTimeout(() => {
                    if (this.VendOutstandingRowData.length > 0) {
                        this.gridApiVendorOustanding.getModel().getRow(0).setSelected(true);
                        setTimeout(() => {
                            this.gridApiVendorOustanding.getModel().getRow(0).setSelected(false);
                        }, 500);
                    }
                    let allColumnIds = [];
                    this.gridColumnApiVendorOustanding.getAllColumns().forEach(function (column) {
                        allColumnIds.push(column.getColId());
                    });
                    this.gridColumnApiVendorOustanding.autoSizeColumns(allColumnIds);
                    this.gridApiVendorOustanding.sizeColumnsToFit();
                }, 100);
            })
    }

    VendorOutstandingGridReady(params) {
        this.gridApiVendorOustanding = params.api;
        this.gridColumnApiVendorOustanding = params.columnApi;
        this.gridApiVendorOustanding.sizeColumnsToFit();
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    exportoutstandingven() {
        let vndrName = this.unitInfo.Company_Name + '\n' + this.unitInfo.Company_Full_Address + '\n' + 'Vendor Name :' + this.Vendor_Name;
        let d = new Date();
        var fName = 'Outstanding_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: vndrName,
            fileName: fName,
        };
        this.gridApiVendorOustanding.exportDataAsCsv(params);
    }

    onPopupFilterTextBoxChanged(e) {
        let value = $('input#filter-text-box1').val();
        this.gridApiVendorOustanding.setQuickFilter(value);
    }

    venKeyDown(event) {
        if (event.which == 13) {
            this.gridApiVendorOustanding.setFocusedCell(0, "Doc_No");
        }
    }

    VendorOutstandingNavigateScreen(event) {
        let parent = this;
        if (event.keyCode == 13 || event.type == "rowDoubleClicked") {
            let focusedCell = this.gridApiVendorOustanding.getFocusedCell();
            if (focusedCell && focusedCell.column["colDef"]["field"] == "Doc_No") {
                let selectedRows = this.gridApiVendorOustanding.getSelectedRows();
                // console.log("Naivgation Data :::: ", selectedRows);
                let TransNo = this.f_chkNum(selectedRows[0].Transaction_No);
                let TransType = this.f_chkNum(selectedRows[0].Transaction_Type);
                let Doc_Date = selectedRows[0].Post_Date;
                if (TransNo > 0) {
                    var data_navi = { "ScreenType": TransType, "Transaction_No": TransNo, "Transaction_Date": Doc_Date }
                    parent.commonFunction.Nevigate_Document_Entry(data_navi);
                }
            }
        }
    }

    vendorOustandingFilter() {

        var self = this;

        let startDate = moment(this.searchobject.From_Date).format('YYYY-MM-DD');
        let endDate = moment(this.searchobject.To_Date).format('YYYY-MM-DD'); 

        const filteredRows = this.VendOutstandingRowData_1.filter(row => {
        let postDate = moment(row.Post_Date).format('YYYY-MM-DD');
        return postDate >= startDate && postDate <= endDate; 
        });

        //console.log(filterData);
        this.VendOutstandingRowData = filteredRows;

        var TotalRowData = { "Doc_No": "Total Count : " + this.VendOutstandingRowData.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

        TotalRowData.Total_BillAmount = (this.VendOutstandingRowData.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.ClrAmt = (this.VendOutstandingRowData.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.Outstanding = (this.VendOutstandingRowData.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);

        setTimeout(() => {
            this.gridApiVendorOustanding.setPinnedBottomRowData([TotalRowData]);
        }, 200);
        setTimeout(() => {
            if (this.VendOutstandingRowData.length > 0) {
                this.gridApiVendorOustanding.getModel().getRow(0).setSelected(true);
            }
            let allColumnIds = [];
            this.gridColumnApiVendorOustanding.getAllColumns().forEach(function (column) {
                allColumnIds.push(column.getColId());
            });
            this.gridColumnApiVendorOustanding.autoSizeColumns(allColumnIds);
            this.gridApiVendorOustanding.sizeColumnsToFit();
        }, 100);
    }

    ClearDateRange() {
        this.searchobject.From_Date = this.Config_Leger_From_Date;
        this.searchobject.To_Date = new Date();
        this.Custfiltervalue = '';
        $('#filter-text-box1').focus();
        this.vendorOustandingmain();
    }
    TotalRowData:any;
    EnableDateRange() {
        var self = this;
        this.searchobject.Enable_DateRange = (this.searchobject.Enable_DateRange == true ? true : false);
        if (this.searchobject.Enable_DateRange == true) {
            this.searchobject.From_Date = this.Config_Leger_From_Date;
            this.searchobject.To_Date = new Date();
        }
        else {
            this.searchobject.From_Date = "";
            this.searchobject.To_Date = "";
            this.VendOutstandingRowData = this.VendOutstandingRowData_1;
            setTimeout(() => {
                this.TotalRowData = { "Doc_No": "Total Count : " + this.VendOutstandingRowData.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

                this.TotalRowData.Total_BillAmount = (this.VendOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                this.TotalRowData.ClrAmt = (this.VendOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                this.TotalRowData.Outstanding = (this.VendOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);

                setTimeout(() => {
                    this.gridApiVendorOustanding.setPinnedBottomRowData([this.TotalRowData]);
                }, 200);
                setTimeout(() => {
                    if (this.VendOutstandingRowData.length > 0) {
                        this.gridApiVendorOustanding.getModel().getRow(0).setSelected(true);
                    }
                    let allColumnIds = [];
                    this.gridColumnApiVendorOustanding.getAllColumns().forEach(function (column) {
                        allColumnIds.push(column.getColId());
                    });
                    this.gridColumnApiVendorOustanding.autoSizeColumns(allColumnIds);
                    this.gridApiVendorOustanding.sizeColumnsToFit();
                }, 100);

            }, 500);

        }
    }

    onSelectionChanged() {
        let self = this;
        try {
            const selectedRows = this.gridApiVendorOustanding && this.gridApiVendorOustanding.getSelectedRows() || [];
            let totalOutstanding = 0;
            let totalBillAmount = 0;
            selectedRows.forEach(row => {
                totalOutstanding += this.f_chkNum(row.Outstanding);
                totalBillAmount += this.f_chkNum(row.Total_BillAmount);
            });
            console.log("totalOutstanding", totalOutstanding);
            let lineRow1 = Object.assign({}, this.TotalRowData);
            let lineRow2 = Object.assign({}, { 
                "Doc_No": "Selected Count : " + selectedRows.length, 
                "Total_BillAmount": "Selected Total :" + totalBillAmount.toFixed(2), 
                // "Bill_No": "Apply",
                "OverDays": "",
                "Outstanding":"Total OS : " + totalOutstanding.toFixed(2),
                "_isLastPinned": true,
                totalOutstanding,
             });
            this.gridApiVendorOustanding.setPinnedBottomRowData([lineRow1, lineRow2]);
        } catch (e) { }

    }

    overDaysCellRenderer(params) {
        const isPinned = params.node && params.node.rowPinned === 'bottom';
        if (!isPinned) return params.value != null ? params.value : '';

        // only render button for row marked as last
        if (!params.data || !params.data._isLastPinned || params.data.totalBillAmount <= 0 ) {
            return params.value != null ? params.value : '';
        }

        const btn = document.createElement('button');
        btn.id = 'applySelectedBtn';
        btn.className = 'btn btn-sm btn-primary';
        btn.type = 'button';
        btn.innerText = 'Apply (alt+s)';
        btn.style.fontSize = '10px';

        btn.addEventListener('click', (e) => { e.stopPropagation(); this.navigateToSelectedTotal(params); });

        const container = document.createElement('div');
        container.appendChild(btn);
        return container;
    }

  navigateToSelectedTotal(params) {
    console.log("navigateToSelectedTotal", params);
    let _amount= params.data.totalOutstanding;
    this.totalAmount.emit(_amount);
  }
}

